<template>
  <div>
    <div v-if="isLoading" class="flex items-center justify-center h-52">
      <aha-spinner size="lg" variant="tail" />
    </div>

    <template v-if="!isLoading">
      <ErrorSlideCopy v-if="hasError" @getAllUserPresentationsAndFolders="loadData" />
      <Presentations
        v-if="hasPresentationToCopyTo"
        :selectedPresentationId="presentationId"
        :presentations="mostRecentPresentations"
        @handlePresentationItemClick="handlePresentationItemClick"
      ></Presentations>
      <template v-if="!hasError">
        <NoPresentationSlideCopy v-if="!hasPresentationToCopyTo" />
      </template>
    </template>
    <slot v-if="hasPresentationToCopyTo" name="interactive-button-section">
    </slot>
  </div>
</template>
<script>
import TabBaseMixin from './TabBaseMixin'
import Presentations from './Presentations.vue'
import SlideCopy from '../SlideCopy.vue'

export default {
  name: 'TabRecent',
  title: 'Recent',
  components: {
    Presentations,
  },
  extends: SlideCopy,
  mixins: [TabBaseMixin],
  methods: {
    async loadData() {
      return this.getAllUserPresentationsAndFolders()
    },
  },
}
</script>
